
const digest = 'b761751b4dd828a3dbc83dac27e70a02950fe2e0e26d18c189d3d136121be315';
const css = `._codeSnippet_1uny7_1 {
  font-family: monospace;
  color: #d14;
  border: 1px solid #e1e1e8;
  padding: 0 4px;
  margin: 0;
  border-radius: 3px;
  background-color: #f7f7f9;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"codeSnippet":"_codeSnippet_1uny7_1"};
export { css, digest };
  